"use client";
import { Row, Col, Table, Badge, Button } from "react-bootstrap";
import { useRef, useState } from "react";
import Breadcrumbs from "../../../components/Breadcrumb";
import { usePathname, useRouter } from "next/navigation";
import ProductDetailSection from "../../../sections/ProductDetails/ProductDetailSection";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useNavigationEvent } from "../../hooks/useNavigationEvent";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchItemDetails, fetchRelatedItems } from "../../apis/getApis";
import styles from "../../../styles/ProductDetail.module.css";
// or the entire module:
import DOMPurify from "isomorphic-dompurify";
import React from "react";
import { useViewListStore } from "../../../store/viewList";
import Error from "next/error";
import ProductCardLoading from "../../../sections/SpecDetails/ProductCardLoading";
import Image from "next/image";
import Link from "next/link";
import Tabstyles from "../../../styles/SpecDetail.module.css";
import imagePlaceholder from "../../../../public/images/imagePlaceholder.png";
import ImageCarousel from "../../../components/ImageCarousel";
import { marketplaceCdn } from "../../../utility/env";
import { replaceSpecialCharacters } from "../../../utility/Images/utils";
import { ViewList } from "../../../sections/ProductDetails/ViewList";
import {
  listing_visit,
  Phone_BtnClick,
  wa_BtnClick,
} from "../../../UserEvents/UserEvents";
import { useUserStore } from "../../../store/User";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { whatsapp } from "../../../../public/icons";
import { faEnvelope, faMessage } from "@fortawesome/free-regular-svg-icons";
import { sendGTMEvent } from "@next/third-parties/google";
import SendEmail from "../../../sections/ProductListing/SendEmail";
import SignInModal from "../../../components/SignInModal";
import { trackContact, trackListingVisit } from "../../../utility/UserEvents";
import { LeadType } from "../../../Constants/userEventEnums";
import OTPModal from "../../../components/User/OTPModal";

function ProductDetails() {
  const [isMounted, setIsMounted] = useState(false);
  const [emailModal, setEmailModal] = useState<boolean>(false);
  const viewList = useViewListStore((state: any) => state?.viewList);
  const setViewList = useViewListStore((state: any) => state?.setViewList);
  const [discriptionText, setDiscriptionText] = useState<string>("");
  const [selectedTab, setSelectedTab] = useState("description");
  const [signInModal, setSignInModal] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otpVerified, setOTPVerified] = useState(false);
  // const [title, setTitle] = useState("");

  const queryClient = useQueryClient();
  const description = useRef<any>();
  const router = useRouter();
  const { user, token } = useUserStore((state: any) => state);
  const userId = user?.uuid;

  const pathname = usePathname();
  let paramArray = pathname.split("-");
  let paramId = paramArray[paramArray.length - 1];
  const [isDescriptionCollapsed, setIsDescriptionCollapsed] = useState(true);
  useNavigationEvent();

  const typeObject: {
    [key: string]: string;
  } = {
    Laptop: "laptopListings",
    Mobile: "mobileListings",
    Tablet: "tabletListings",
    "TV / Monitor": "tvMonitorListings",
    "Desktop Computer": "desktopListings",
    Accessories: "accessoryListings",
  };

  const FetchItemDetails = useQuery({
    queryKey: ["itemDetails", paramId],
    queryFn: () => fetchItemDetails(paramId),
    enabled: !!paramId?.toString(),
    onSuccess: (data: any) => {
      setIsMounted(true);
      const fetchedData = data?.data?.body?.data;
      const text =
        fetchedData[typeObject[fetchedData?.item?.["categoriesTable"].label]]
          ?.description;
      setDiscriptionText(text);
      setViewList({
        image: fetchedData.item.itemImages[0],
        listing_title: fetchedData.listing_title,
        online_price: fetchedData.online_price,
        online_discount: fetchedData.online_discount,
        online_discount_unit: fetchedData.online_discount_unit,
        listing_id: fetchedData.listing_id,
        item: fetchedData.item,
        effective_price: fetchedData?.effective_price,
      });
    },
    onError: (error: any) => {
      (error.response.status === 404 || error.response.status === 500) &&
        router.replace("/404");
    },
  });

  const fetchedData = FetchItemDetails?.data?.data?.body?.data;
  const title =
    `products/${fetchedData?.listing_title?.replaceAll(" ", "-").replaceAll("/", "--")}-${fetchedData?.listing_id}`.replace(
      /\n/g,
      ""
    );

  const FetchRelatedProducts = useQuery({
    queryKey: ["relatedProducts", paramId],
    queryFn: () => fetchRelatedItems(paramId),
    enabled: !!paramId?.toString(),
  });
  const relatedProducts = FetchRelatedProducts?.data?.data?.body?.data;
  const capitalize = (data: any) => {
    return data.charAt(0).toUpperCase() + data.slice(1);
  };

  const sanitizedHTML = DOMPurify.sanitize(discriptionText);
  let SpecsObject = fetchedData
    ? fetchedData[typeObject[fetchedData?.item?.["categoriesTable"].label]]
    : [];

  return (
    <>
      {!FetchItemDetails?.isLoading &&
        replaceSpecialCharacters(title)
          .trim()
          .replaceAll("--", "")
          .toLocaleLowerCase() !==
        replaceSpecialCharacters(
          decodeURIComponent(
            pathname.replace("/", "").replaceAll("--", "")
          ).trim()
        ) ? null : (
        <GoogleReCaptchaProvider
          reCaptchaKey={`${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
        >
          <div className={`${styles.productDetails}`}>
            <main className="main px-3">
              <Breadcrumbs />
              <Row className="my-4">
                <Col xs="12" sm="12" md="6" lg="7">
                  <ImageCarousel
                    fetchedData={fetchedData?.item?.itemImages}
                    video={fetchedData?.video}
                  />
                </Col>
                <Col xs="12" sm="12" md="6" lg="5">
                  <ProductDetailSection
                    isLoading={FetchItemDetails.isLoading}
                    fetchedData={fetchedData}
                  />
                </Col>
              </Row>
              <Row className="w-100 ">
                <Col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="4"
                  className="mt-4 mt-lg-0 d-grid order-sm-1 order-1 order-lg-0 d-md-block"
                >
                  {FetchRelatedProducts?.isSuccess &&
                    relatedProducts.length === 0 ? (
                    <></>
                  ) : (
                    <>
                      <h5
                        className={` fs-18 mt-3 border-bottom text-center pb-1 ${styles.re_heading}`}
                      >
                        Related Models
                      </h5>
                      <div
                        className={`d-flex flex-row flex-wrap p-1 gap-3 justify-content-center justify-content-lg-center`}
                      >
                        {FetchRelatedProducts.isLoading
                          ? Array.from(Array(10)).map(
                            (item: any, index: number) => (
                              <ProductCardLoading key={index} />
                            )
                          )
                          : relatedProducts?.map((item: any, index: number) => (
                            <ProductCard
                              key={index}
                              title={item.listing_title}
                              imageUrl={item.item.itemImages?.img0}
                              id={item.listing_id}
                              price={item.effective_price}
                            // category={category}
                            />
                          ))}
                      </div>
                    </>
                  )}
                </Col>

                <Col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="8"
                  className={`px-0 px-3 mb-4 mb-md-0  mt-3`}
                  ref={description}
                >
                  {discriptionText?.length > 0 ? (
                    <>
                      {" "}
                      <Row
                        className={`${Tabstyles.tabOptionsContainer} rounded-top w-100 m-0 `}
                      >
                        <Col
                          col={6}
                          className={`${Tabstyles.tabOptions} 
                                  ${selectedTab === "description" ? `${Tabstyles.activeTabOption} ${Tabstyles.endBorderImportant}` : ""} rounded-top border-end-0`}
                          onClick={() => setSelectedTab("description")}
                        >
                          Description
                        </Col>
                        <Col
                          col={6}
                          className={`${Tabstyles.tabOptions} ${selectedTab === "specifications" ? `${Tabstyles.activeTabOption} ${Tabstyles.endBorderImportant}` : ""}
                                  rounded-top border-end`}
                          onClick={() => setSelectedTab("specifications")}
                        >
                          Specifications
                        </Col>
                      </Row>
                      <div
                        className={`w-100 bg-light border border-top-0 px-2 rounded-bottom`}
                      >
                        {selectedTab === "description" ? (
                          discriptionText?.length > 0 ? (
                            <>
                              <div
                                style={
                                  isDescriptionCollapsed &&
                                    discriptionText.replace(/(<([^>]+)>)/gi, "")
                                      .length > 1500
                                    ? { maxHeight: "400px", overflow: "hidden" }
                                    : { height: "auto" }
                                }
                                dangerouslySetInnerHTML={{
                                  __html: sanitizedHTML,
                                }}
                              ></div>
                              {sanitizedHTML.replace(/(<([^>]+)>)/gi, "")
                                ?.length >= 1500 && (
                                  <span
                                    className="link cursor-pointer"
                                    onClick={() => {
                                      if (isDescriptionCollapsed) {
                                        setIsDescriptionCollapsed(false);
                                      } else {
                                        if (description.current) {
                                          description.current.scrollIntoView({
                                            behavior: "smooth",
                                          });
                                        }
                                        setIsDescriptionCollapsed(true);
                                      }
                                    }}
                                  >
                                    {isDescriptionCollapsed
                                      ? "Read More >>"
                                      : "<< Read Less"}
                                  </span>
                                )}
                            </>
                          ) : null
                        ) : (
                          <Table
                            className={`${styles.specsTable} m-0 border-0`}
                          >
                            {SpecsObject &&
                              Object.keys(SpecsObject).length > 0 &&
                              Object.entries(SpecsObject)
                                ?.filter(
                                  ([key, value]) =>
                                    !key.includes("fk") &&
                                    !key.includes("id") &&
                                    !key.includes("description")
                                )
                                ?.map(([key, value]: any, indexCat: number) => (

                                  <React.Fragment key={indexCat}>
                                    <>
                                      <tbody>
                                        <tr
                                          key={indexCat}
                                          className="d-flex justify-content-between mx-1"
                                        >
                                          <td
                                            colSpan={1}
                                            style={{ background: "none" }}
                                          >
                                            {capitalize(
                                              key
                                                .replaceAll(/_/g, " ")
                                                .replaceAll("is", " ")
                                            )}
                                          </td>
                                          <td
                                            colSpan={8}
                                            style={{ background: "none" }}
                                          >
                                            {" "}
                                            {value === "nil" || value === "null"
                                              ? "--"
                                              : value == 0
                                                ? "No"
                                                : value == 1
                                                  ? "Yes"
                                                  : value}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </>
                                  </React.Fragment>
                                ))}
                          </Table>
                        )}
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {fetchedData?.notes ? (
                    <>
                      <Row
                        className={`${Tabstyles.tabOptionsContainer} rounded-top w-100 m-0  pt-5`}
                      >
                        <Col
                          col={6}
                          className={`${Tabstyles.tabOptions} 
                          ${Tabstyles.activeTabOption} rounded-top border-end-0`}
                        >
                          Seller Notes
                        </Col>
                      </Row>
                      <div
                        style={{ overflowWrap: "anywhere" }}
                        className={`w-100 bg-light border border-top-0 px-2 rounded-bottom`}
                      >
                        {fetchedData?.notes}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              <div
                className={`${styles.bottomButton} p-2 d-block d-md-none d-lg-none d-xl-none d-xxl-none`}
              >
                <Button
                  className="w-100 "
                  onClick={() => {
                    trackContact(
                      fetchedData.item.shopTable.shop_id,
                      user ? userId : null,
                      LeadType.PHONE,
                      fetchedData?.item?.location?.location_number,
                      `${process.env.NEXT_PUBLIC_MARKETPLACE_URL
                      }products/${fetchedData?.listing_title
                        .replaceAll(" ", "-")
                        .replaceAll("/", "")}-${fetchedData?.listing_id}`,
                      fetchedData.item.shopTable.shop_name
                    );
                    if (user) {
                      window.open(
                        `tel: ${fetchedData?.item.shopTable?.on_payment || fetchedData?.item?.location?.city?.city_name === "Karachi" ? fetchedData?.item?.location?.location_number : "+923104447724"}`,
                        "_self"
                      );
                    } else {
                      setShowOTPModal(true);
                    }
                    // setShowNumbers(true);
                  }}
                >
                  <FontAwesomeIcon
                    className={`${styles.whatsappIcon} me-2`}
                    fontSize={16}
                    icon={faPhone}
                  />{" "}
                  <span className={`fs-14 `}>Contact Seller</span>
                </Button>
                <div className=" w-100 d-flex align-items-center justify-content-between px-2 py-1 ">
                  <div
                    onClick={() => {
                      trackContact(
                        fetchedData.item.shopTable.shop_id,
                        user ? userId : null,
                        LeadType.WHATSAPP,
                        fetchedData?.item?.location?.location_number,
                        `${process.env.NEXT_PUBLIC_MARKETPLACE_URL
                        }products/${fetchedData?.listing_title
                          .replaceAll(" ", "-")
                          .replaceAll("/", "")}-${fetchedData?.listing_id}`,
                        fetchedData.item.shopTable.shop_id
                      );
                      window.open(
                        `https://wa.me/${fetchedData?.item?.shopTable?.on_payment || fetchedData?.item?.location?.city?.city_name === "Karachi" ? fetchedData?.item?.location?.location_number.replace("+92", 92)
                          .replaceAll(
                            "-",
                            ""
                          ) : "+923104447724"
                            .replace("+92", 92)
                            .replaceAll(
                              "-",
                              ""
                            )}?text=Hello, I am interested in your item ${fetchedData?.url
                        } `
                      );
                    }}
                    className={`d-flex align-items-center  justify-content-center   rounded-1 cursor-pointer `}
                  >
                    {/* <FontAwesomeIcon
                className={`${styles.whatsappIcon} mx-2`}
                fontSize={20}
                icon={faWhatsapp}
              /> */}
                    <Image
                      className="mt-1 me-1"
                      src={whatsapp}
                      alt="whatsapp"
                      width={28}
                      height={28}
                    />
                    <span className="text-white">Whatsapp</span>
                  </div>
                  <div
                    onClick={() => {
                      // Phone number and default message
                      const phoneNumber =
                        fetchedData?.item?.shopTable?.on_payment || fetchedData?.item?.location?.city?.city_name === "Karachi" ? fetchedData?.item?.location?.location_number : "+923104447724"; // Replace with the actual seller's phone number
                      const defaultMessage =
                        "Hello, I am interested in your product. Can we discuss further?";

                      // Create the SMS link
                      const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(defaultMessage)}`;

                      // Redirect to the SMS app
                      window.location.href = smsLink;
                    }}
                    className={`d-flex align-items-center  justify-content-center   mt-2  mb-2 rounded-1 cursor-pointer`}
                  >
                    <FontAwesomeIcon
                      className={`${styles.emailIcon} text-white `}
                      fontSize={22}
                      icon={faMessage}
                    />
                    <span className="ms-1 text-white ">Chat</span>
                  </div>
                  <div
                    onClick={() => {
                      // sendGTMEvent({
                      //   event: `Interested-Email`,
                      //   value: fetchedData.item.shopTable.shop_id,
                      //   action: "cilck",
                      //   location: "PDP",
                      //   ListingId: fetchedData?.listing_id,
                      //   shopId: fetchedData.item.shopTable.shop_id,
                      // });
                      setEmailModal(true);
                    }}
                    className={`d-flex align-items-center  justify-content-center   mt-2  mb-2 rounded-1 cursor-pointer`}
                  >
                    <FontAwesomeIcon
                      className={`${styles.emailIcon} text-white `}
                      fontSize={22}
                      icon={faEnvelope}
                    />
                    <span className="ms-1 text-white ">Email</span>
                  </div>
                </div>
              </div>
            </main>
            {/* {relatedProducts?.length > 0 && <RelatedProducts relatedProducts={relatedProducts} />} */}
            {viewList?.length > 1 && (
              <ViewList paramId={paramId} relatedProducts={viewList} />
            )}
          </div>
          <SendEmail
            shopData={fetchedData}
            show={emailModal}
            onHide={() => setEmailModal(false)}
          />
        </GoogleReCaptchaProvider>
      )}

      <SignInModal
        // title={title}
        show={signInModal}
        onHide={() => setSignInModal(false)}
      />
      <OTPModal
        show={showOTPModal}
        onHide={() => setShowOTPModal(false)}
        setOTPVerified={setOTPVerified}
        otpVerified={otpVerified}
        shop_name={fetchedData?.item?.shopTable?.shop_name}
      />
    </>
  );
}

export default ProductDetails;

export const ProductCard = ({ title, id, imageUrl, price }: any) => {
  const { user, token } = useUserStore((state: any) => state);
  const router = useRouter();
  const [imageSrc, setImageSrc] = useState(`${marketplaceCdn}/${imageUrl}`);
  return (
    <Link
      onClick={() =>
        trackListingVisit(
          id,
          user?.uuid,
          "PDP",
          title,
          `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/products/${replaceSpecialCharacters(
            title.replaceAll(" ", "-").replaceAll("/", "").replaceAll("--", "")
          ).trim()}-${id}`
        )
      }
      href={`/products/${replaceSpecialCharacters(title.replaceAll(" ", "-").replaceAll("/", "").replaceAll("--", ""))}-${id}`}
    >
      <div
        style={{
          width: "128px",
          height: "200px",
          border: "1px solid #dee2e6",
          borderRadius: "10px",
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        <div style={{ width: "128px", height: "128px" }}>
          <Image
            alt="modelImage"
            src={imageSrc}
            width={300}
            height={300}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            onError={(e) => {
              setImageSrc(`${imagePlaceholder.src}`);
            }}
          />
        </div>
        <div className="d-flex flex-column">
          <p
            style={{
              margin: "0",
              padding: "0 5px",
              height: "40px",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3, // Number of lines before applying ellipsis
              textOverflow: "ellipsis",
              fontSize: "0.8rem",
              fontWeight: "500",
            }}
          >
            {title}
          </p>
          <h5 className="fs-12 m-1 justify-content-end">
            Rs. <span className="fs-9">{price}</span>
          </h5>
        </div>
      </div>
    </Link>
  );
};
